import { SharedLink } from '@/types';

export const demoSharedLinks: SharedLink[] = [];